import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useAuth from '../../auth/useAuth';
import { confirmEmailChange } from '../../services/userService';
import '../Login/Login.css';
import './ConfirmEmailChangePage.css';

const CONTENT = {
  loading: ['Verifying your new email...', 'Please wait.'],
  missing: ['Email change link is invalid', 'The email change token is missing.'],
  success: ['Email changed successfully', 'Your ASiJoLab email address has been updated.'],
  invalid: ['Email change failed', 'Invalid or expired email change link.'],
  conflict: ['Email change failed', 'This email address cannot be used.'],
  error: ['Email change failed', 'Unable to change the email address. Please try again later.'],
};

const ConfirmEmailChangePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const token = searchParams.get('token')?.trim() || '';
  const [state, setState] = useState(token ? 'loading' : 'missing');

  useEffect(() => {
    if (!token) return undefined;
    let active = true;

    confirmEmailChange(token)
      .then(async () => {
        await refreshUser();
        if (active) setState('success');
      })
      .catch((error) => {
        if (!active) return;
        const status = error?.response?.status;
        setState(status === 400 ? 'invalid' : status === 409 ? 'conflict' : 'error');
      });

    return () => { active = false; };
  }, [token, refreshUser]);

  const [title, text] = CONTENT[state];
  const loading = state === 'loading';

  return (
    <main className="loginPage">
      <section className="loginCard confirmEmailChangeCard" aria-busy={loading}>
        {loading && <div className="spinner-border confirmEmailChangeSpinner" role="status" aria-label="Verifying email" />}
        <h1>{title}</h1>
        <p>{text}</p>
        {!loading && (
          <button className="loginSubmitButton confirmEmailChangeButton" type="button" onClick={() => navigate(state === 'success' && user ? '/profile' : '/login')}>
            {state === 'success' && user ? 'Go to Profile' : 'Go to Sign In'}
          </button>
        )}
      </section>
    </main>
  );
};

export default ConfirmEmailChangePage;
